module.exports = __webpack_public_path__ + "static/images/sc.30ef8a3.jpg";